import { useGSAP } from '@gsap/react';
import gsap from 'gsap';
import * as React from 'react';
import { imageAnimationParamsCenter, imageAnimationParamsRight } from './constants';
function useParallax(displayStyle) {
    const containerRef = React.useRef(null);
    useGSAP(() => {
        const mm = gsap.matchMedia();
        mm.add('(min-width: 768px) and (prefers-reduced-motion: no-preference)', () => {
            const timeline = gsap.timeline({
                scrollTrigger: {
                    scrub: true,
                    trigger: containerRef.current,
                    start: 'top 130%',
                    end: '50% top',
                    markers: process.env.NODE_ENV === 'development',
                },
            });
            const animationParams = displayStyle === 'central' ? imageAnimationParamsCenter : imageAnimationParamsRight;
            const images = gsap.utils.toArray('[data-loco-img]');
            images.forEach((img, index) => {
                // Adding will-change & backface-visibility to fix Safari rendering issues
                img.style.willChange = 'transform, filter';
                img.style.backfaceVisibility = 'hidden';
                const params = animationParams[index % animationParams.length];
                const { initialY, finalY, initialBlur, finalBlur } = params;
                timeline.fromTo(img, {
                    y: initialY,
                    filter: `blur(${initialBlur})`,
                }, {
                    y: finalY,
                    filter: `blur(${finalBlur})`,
                    duration: 1,
                }, index === 0 ? undefined : '<');
            });
        });
        mm.add('(max-width: 767px) and (prefers-reduced-motion: no-preference)', () => {
            const timeline = gsap.timeline({
                scrollTrigger: {
                    scrub: true,
                    trigger: containerRef.current,
                    start: 'top 130%',
                    end: '70% top',
                    markers: process.env.NODE_ENV === 'development',
                },
            });
            const animationParams = displayStyle === 'central' ? imageAnimationParamsCenter : imageAnimationParamsRight;
            const images = gsap.utils.toArray('[data-loco-img]');
            images.forEach((img, index) => {
                // Adding will-change & backface-visibility to fix Safari rendering issues
                img.style.willChange = 'transform, filter';
                img.style.backfaceVisibility = 'hidden';
                const params = animationParams[index % animationParams.length];
                const { initialY, finalY, initialBlur, finalBlur } = params;
                timeline.fromTo(img, {
                    y: initialY,
                    filter: `blur(${initialBlur})`,
                }, {
                    y: finalY,
                    filter: `blur(${finalBlur})`,
                    duration: 1,
                }, index === 0 ? undefined : '<');
            });
        });
    }, { scope: containerRef, dependencies: [displayStyle] });
    return containerRef;
}
export default useParallax;
